import { Component, ReactNode } from 'react';

interface SecondaryTitleHeaderState {
  isVisible: boolean;
}

interface SecondaryTitleHeaderProps {
  title: ReactNode;
  backgroundColor?: string;
}

class SecondaryTitleHeader extends Component<SecondaryTitleHeaderProps, SecondaryTitleHeaderState> {
  constructor(props: SecondaryTitleHeaderProps) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const isVisible = window.scrollY > 100;
    if (this.state.isVisible !== isVisible) {
      this.setState({ isVisible });
    }
  };

  render() {
    const { isVisible } = this.state;
    const { title, backgroundColor } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <div
        className={`c-ssa-secondary-title-header ${backgroundColor || 'c-ssa-secondary-title-header--background-color'}`}
        data-testid="ssa-secondary-title-header"
      >
        <h2><strong data-testid="ssa-secondary-title-header-title">{title}</strong></h2>
      </div>
    );
  }
}

export default SecondaryTitleHeader;
